export const profileSyncValuesPair = {
    templateUrl: Evisors.config.cdnRootWhitelabel + 'asset/partials/user/components/profileSyncValuesPair.html',
    bindings: {
        title: '@',
        item: '<',
    },
};
